/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-token-renewal',
    templateUrl: './token-renewal.component.html'
})
export class TokenRenewalComponent implements OnInit {

    constructor(private route: ActivatedRoute) {
    }

    renewalDetail: any;

    ngOnInit(): void {
        console.log("route:", this.route)
        this.renewalDetail = this.route.snapshot.params['trd'];
    }

}
